"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
const _tagged_template_literal = require("@swc/helpers/_/_tagged_template_literal");
function _templateObject() {
    const data = _tagged_template_literal._([
        "\n  query SearchResultsFacets($query: String!, $facetFiltering: [PlpRowsFacetFilterInput!]) {\n    application {\n      productSearchPage {\n        products(query: $query, topRows: 1, facetFiltering: $facetFiltering) {\n          facets {\n            ...ProductListingFacets\n          }\n        }\n      }\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.searchResultsFacetsQuery = void 0;
var _fetching = require("@ori/fetching");
var _productListingFacets = require("./fragments/productListingFacets");
const searchResultsFacetsQuery = exports.searchResultsFacetsQuery = (0, _fetching.gql)(_templateObject(), _productListingFacets.productListingFacets);
